const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCarGarageRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#efdfe7"
    },
    d: "M 2.5 38.5 L 2.5 10.265625 L 19.996094 3.535156 L 37.5 10.265625 L 37.5 38.5 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ba265d"
    },
    d: "M 19.996094 4.070313 L 37 10.609375 L 37 38 L 3 38 L 3 10.609375 L 19.996094 4.070313 M 19.996094 3 L 2 9.921875 L 2 39 L 38 39 L 38 9.921875 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ca6a8e"
    },
    d: "M 19.996094 5.457031 L 1.5 13.246094 L 1.5 9.332031 L 19.996094 1.542969 L 38.5 9.332031 L 38.5 13.246094 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ba265d"
    },
    d: "M 19.996094 2.085938 L 38 9.664063 L 38 12.492188 L 20.386719 5.078125 L 19.996094 4.914063 L 19.609375 5.078125 L 2 12.492188 L 2 9.664063 L 19.996094 2.085938 M 19.996094 1 L 1 9 L 1 14 L 19.996094 6 L 39 14 L 39 9 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ca6a8e"
    },
    d: "M 8.101563 27.5 C 7.21875 27.5 6.5 26.828125 6.5 26 C 6.5 25.171875 7.21875 24.5 8.101563 24.5 L 31.898438 24.5 C 32.78125 24.5 33.5 25.171875 33.5 26 C 33.5 26.828125 32.78125 27.5 31.898438 27.5 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ba265d"
    },
    d: "M 31.898438 25 C 32.507813 25 33 25.449219 33 26 C 33 26.550781 32.507813 27 31.898438 27 L 8.101563 27 C 7.492188 27 7 26.550781 7 26 C 7 25.449219 7.492188 25 8.101563 25 L 31.898438 25 M 31.898438 24 L 8.101563 24 C 6.941406 24 6 24.894531 6 26 C 6 27.105469 6.941406 28 8.101563 28 L 31.898438 28 C 33.058594 28 34 27.105469 34 26 C 34 24.894531 33.058594 24 31.898438 24 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ba265d"
    },
    d: "M 32 32.570313 L 32 37 C 32 37.550781 31.550781 38 31 38 L 28 38 C 27.449219 38 27 37.550781 27 37 L 27 32.570313 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ba265d"
    },
    d: "M 13 32.570313 L 13 37 C 13 37.550781 12.550781 38 12 38 L 9 38 C 8.449219 38 8 37.550781 8 37 L 8 32.570313 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ca6a8e"
    },
    d: "M 8.5 35.5 L 8.5 28.082031 L 9.476563 25.15625 L 11.777344 19.03125 C 12.089844 18.109375 12.929688 17.5 13.886719 17.5 L 26 17.5 C 26.953125 17.5 27.796875 18.109375 28.101563 19.015625 L 30.535156 25.183594 L 31.5 28.082031 L 31.5 35.5 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ba265d"
    },
    d: "M 26 18 C 26.738281 18 27.394531 18.472656 27.625 19.171875 L 27.636719 19.199219 L 27.644531 19.222656 L 30.058594 25.34375 L 31 28.160156 L 31 35 L 9 35 L 9 28.160156 L 9.9375 25.351563 L 12.257813 19.171875 C 12.492188 18.472656 13.144531 18 13.886719 18 L 26 18 M 26 17 L 13.886719 17 C 12.71875 17 11.679688 17.746094 11.308594 18.855469 L 9 25 L 8 28 L 8 36 L 32 36 L 32 28 L 31 25 L 28.574219 18.855469 C 28.207031 17.746094 27.167969 17 26 17 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M 29 29.5 C 29 30.328125 28.328125 31 27.5 31 C 26.671875 31 26 30.328125 26 29.5 C 26 28.671875 26.671875 28 27.5 28 C 28.328125 28 29 28.671875 29 29.5 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M 14 29.5 C 14 30.328125 13.328125 31 12.5 31 C 11.671875 31 11 30.328125 11 29.5 C 11 28.671875 11.671875 28 12.5 28 C 13.328125 28 14 28.671875 14 29.5 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DFF0FE"
    },
    d: "M 14.566406 35.5 L 15.613281 32.503906 C 15.824219 31.902344 16.394531 31.5 17.03125 31.5 L 22.96875 31.5 C 23.605469 31.5 24.175781 31.902344 24.386719 32.503906 L 25.433594 35.5 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ba265d"
    },
    d: "M 22.96875 32 C 23.394531 32 23.773438 32.269531 23.914063 32.667969 L 24.730469 35 L 15.269531 35 L 16.085938 32.667969 C 16.226563 32.269531 16.605469 32 17.03125 32 L 22.96875 32 M 22.96875 31 L 17.03125 31 C 16.179688 31 15.425781 31.535156 15.144531 32.339844 L 13.859375 36 L 26.140625 36 L 24.855469 32.339844 C 24.574219 31.535156 23.816406 31 22.96875 31 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DFF0FE"
    },
    d: "M 9.734375 24.5 L 11.890625 19.039063 C 12.203125 18.109375 13.046875 17.5 14 17.5 L 26 17.5 C 26.953125 17.5 27.796875 18.109375 28.101563 19.015625 L 30.265625 24.5 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ba265d"
    },
    d: "M 26 18 C 26.738281 18 27.394531 18.472656 27.625 19.171875 L 27.636719 19.199219 L 27.644531 19.222656 L 29.53125 24 L 10.46875 24 L 12.355469 19.222656 L 12.363281 19.199219 L 12.375 19.171875 C 12.605469 18.472656 13.261719 18 14 18 L 26 18 M 26 17 L 14 17 C 12.832031 17 11.792969 17.746094 11.425781 18.855469 L 9 25 L 31 25 L 28.574219 18.855469 C 28.207031 17.746094 27.167969 17 26 17 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ca6a8e"
    },
    d: "M 8.382813 25 L 31.761719 25 L 31.761719 27 L 8.382813 27 Z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarGarageRed);
export default __webpack_public_path__ + "static/media/car-garage-red.93e5b2294b12b3785a74685ba666e4ce.svg";
export { ForwardRef as ReactComponent };